import React from 'react';
import { Container, Row } from 'reactstrap';
import BestSellerTable from './BestSellerTable';
import BrowserStatistics from './BrowserStatistics';
import GoalOverview from './GoalOverview';
import Greeting from './Greeting';
import OurTotalProfit from './OurTotalProfit';
import ProductDelivery from './ProductDelivery';
import TopSellingProduct from './TopSellingProduct';
import WidgetCard from './WidgetCard';

const ContainerEcommerce = () => {
  return (
    <Container fluid={true} className='default-dash2'>
      <Row>
        <WidgetCard />
        <GoalOverview />
        <BrowserStatistics />
        <ProductDelivery />
        <OurTotalProfit />
        <TopSellingProduct />
        <BestSellerTable />
        <Greeting />
      </Row>
    </Container>
  );
};

export default ContainerEcommerce;
